import React from 'react';

export default function Pagination({ page, pages, onPageChange }) {
  if (pages <= 1) return null;

  return (
    <div className="pagination">
      <button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>Prev</button>
      {Array.from({ length: Math.min(pages, 5) }, (_, i) => {
        const start = Math.max(1, Math.min(page - 2, pages - 4));
        const p = start + i;
        if (p > pages) return null;
        return (
          <button key={p} className={p === page ? 'active' : ''} onClick={() => onPageChange(p)}>
            {p}
          </button>
        );
      })}
      <button disabled={page >= pages} onClick={() => onPageChange(page + 1)}>Next</button>
    </div>
  );
}
